export default [{
    path: 'company',
    component: () => import('@/views/organization/company/company.main'),
    children: [{
        path: 'list',
        components: {
            list: () => import('@/views/organization/company/company.list'),
        },
    }, {
        path: 'detail',
        components: {
            detail: () => import('@/views/organization/company/company.detail'),
        },
    }]
}]